export default {
  title: {
    id: 'funnel_summary_title_with_details',
    defaultMessage: 'Your order',
  },
  giftCardNonRefundable: {
    id: 'checkout_summary_gift_card_non_refundable',
    defaultMessage: 'All gift card sales are final and non-refundable.',
  },
  securePayment: {
    id: 'cart_secure_payment',
    defaultMessage: 'Secure payment',
  },
  total: {
    id: 'checkout_summary_total',
    defaultMessage: 'Total',
  },
  subtotal: {
    id: 'checkout_summary_subtotal',
    defaultMessage: 'Subtotal',
  },
}
